import api from "./api";
import TokenService from "./token.service";

const validateEmail = (email) => {
    return api.post("api/auth/validateEmail/" + email);
};

const updatePassword = (request) => {
    return api.post("api/auth/updatePassword", request);
};

const register = (request) => {
    return api.post("api/auth/signup", request);
};

const login = (email, password, dni, client) => {
    return api
        .post("api/auth/signin", {
            email,
            password,
            dni,
            client
        })
        .then((response) => {
            if (response.data.accessToken) {
                TokenService.setUser(response.data);
            }
            return response.data;
        });
};

const addLogin = (email, password, dni, client, role, instance, entityId) => {
    return api
        .post("api/auth/addLogin", {
            email,
            password,
            dni,
            client,
            role,
            instance,
            entityId
        })
        .then((response) => {
            return response.data;
        });
};

const logout = (email, instance, entityId) => {
    TokenService.removeUser();
    if (email) {
        return api
            .post("api/auth/signout/" + email + "/" + instance + "/" + entityId)
            .then((response) => {
                return response.data;
            });
    }
};

const getCurrentUser = () => {
    return JSON.parse(localStorage.getItem("user"));
};

const getRoles = () => {
    return api.get("roles/findAll?client=pristine&instance=wbSb0");
}

const AuthService = {
    register,
    login,
    logout,
    getCurrentUser,
    validateEmail,
    updatePassword,
    getRoles,
    addLogin
};

export default AuthService;